import { request } from '../request'
import { PostEditRequest } from '../types'

export class PostEditRequestsService {

  getPostEditRequests(customerId: number, postId: number): Promise<PostEditRequest[]> {
    return request.get(`/api/customers/${customerId}/posts/${postId}/edit_requests.json`)
  }

  updatePostEditRequests(customerId: number, postId: number, content: string, editRequests: PostEditRequest[]): Promise<PostEditRequest[]> {
    let tasks = editRequests.map((editRequest: any) => {
      return {
        id: editRequest.id,
        uniq_id: editRequest.uniqId,
        request_type: editRequest.requestType,
        content: editRequest.content,
        post_selected_content: editRequest.postSelectedContent,
        state: editRequest.state
      }
    })

    return request.put(`/api/customers/${customerId}/posts/${postId}/edit_requests.json`, {
      content: content,
      tasks: tasks
    })
  }
}
